import { ReactComponent as IdHorizontalIcon } from '../../../../assets/themes/vastbank/icons/horizontal-id-icon.svg'
import { ReactComponent as IdVerticalIcon } from '../../../../assets/themes/vastbank/icons/vertical-id-icon.svg'
import { ReactComponent as RefreshIcon } from '../../../../assets/themes/vastbank/icons/refresh-icon.svg'
import { ReactComponent as CheckIcon } from '../../../../assets/themes/vastbank/icons/check-icon.svg'
import { ReactComponent as UserIcon } from '../../../../assets/themes/vastbank/icons/user-icon.svg'
import { ReactComponent as SelfieIcon } from '../../../../assets/themes/vastbank/icons/selfie-icon.svg'
import {Icons} from "./Icons";

const VastBankIcons: Icons = {
    idHorizontal: <IdHorizontalIcon/>,
    idVertical: <IdVerticalIcon/>,
    intPassport: <IdHorizontalIcon/>,
    user: <UserIcon/>,
    check: <CheckIcon/>,
    refresh: <RefreshIcon/>,
    selfie: <SelfieIcon/>
}

export default VastBankIcons